import type * as Types from '../../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type UserSearchCreateMutationVariables = Types.Exact<{
  input: Types.UserSearchCreateInput;
}>;

export type UserSearchCreateMutation = {
  __typename?: 'Mutation';
  userSearchCreate?: {
    __typename?: 'UserSearch';
    id: string;
    searchString?: string | null;
    searchUrl?: string | null;
  } | null;
};

export type UserDeleteSearchesMutationVariables = Types.Exact<{ [key: string]: never }>;

export type UserDeleteSearchesMutation = {
  __typename?: 'Mutation';
  userDeleteSearches?: { __typename?: 'User'; id: string } | null;
};

export const UserSearchCreateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'userSearchCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserSearchCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearchCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'searchString' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'searchUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class UserSearchCreateGQL extends Apollo.Mutation<UserSearchCreateMutation, UserSearchCreateMutationVariables> {
  document = UserSearchCreateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const UserDeleteSearchesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'userDeleteSearches' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userDeleteSearches' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class UserDeleteSearchesGQL extends Apollo.Mutation<
  UserDeleteSearchesMutation,
  UserDeleteSearchesMutationVariables
> {
  document = UserDeleteSearchesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
